import { ReferenceDataDto } from '../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IProvincesState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState: IProvincesState = {
  list: [],
  isLoading: false,
};